import React from "react"
import Layout from "../components/Layout"
import "../styles/pages/about.scss"
import { graphql, PageProps } from "gatsby"
import Img from "gatsby-image"
import { Newsletter, GatsbyImage } from "@wp/ui"
import ReactWOW from "react-wow"
import "animate.css"

type AboutPageData = {
  image: GatsbyImage
}

const AboutPage: React.FC<PageProps<AboutPageData>> = ({ data }) => {
  const {
    image: {
      childImageSharp: { fluid: aboutPageBanner },
    },
  } = data
  return (
    <Layout title="About">
      <main id="about-page" className="page-container">
        <article className="about-content">
          <ReactWOW animation="fadeIn">
            <h1 className=" font-alt font-lg font-w-400 animate__animated">
              Writers Print is a blazing fast, beautiful Gatsby blog theme
              designed to showcasw your work in style. Perfect for designers,
              artists, photographers and developers to use for their blog
              websites.
            </h1>
          </ReactWOW>
          <ReactWOW animation="fadeIn">
            <div className="banner-image animate__animated">
              <Img fluid={aboutPageBanner} alt="about page banner" />
            </div>
          </ReactWOW>
          <section className="article-story">
            <ReactWOW animation="fadeIn">
              <h2 className="font-head font-lg animate__animated">Our story</h2>
            </ReactWOW>
            <ReactWOW animation="fadeIn">
              <p className="font-body font-sm animate__animated">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Velit
                et officiis non reprehenderit. Fuga mollitia aperiam accusantium
                accusamus dolor voluptatum quidem nihil harum nostrum
                repellendus Lorem ipsum dolor sit amet consectetur, adipisicing
                elit. Velit et officiis non reprehenderit. Fuga mollitia aperiam
                accusantium accusamus dolor voluptatum quidem nihil harum
                nostrum repellendus Lorem ipsum dolor sit amet consectetur,
                adipisicing elit. Velit et officiis non reprehenderit. Fuga
                mollitia aperiam accusantium accusamus dolor voluptatum quidem
                nihil harum nostrum repellendus Lorem ipsum dolor sit amet
                consectetur, adipisicing elit. Velit et officiis non
                reprehenderit. Fuga mollitia aperiam accusantium accusamus dolor
                voluptatum quidem nihil harum nostrum repellendus Lorem ipsum
                dolor sit amet consectetur, adipisicing elit. Velit et officiis
                non reprehenderit. Fuga mollitia aperiam accusantium accusamus
                dolor voluptatum quidem nihil harum nostrum repellendus Lorem
                ipsum dolor sit amet consectetur, adipisicing elit. Velit et
                officiis non reprehenderit. Fuga mollitia aperiam accusantium
                accusamus dolor voluptatum quidem nihil harum nostrum
                repellendus Lorem ipsum dolor sit amet consectetur, adipisicing
                elit. Velit et officiis non reprehenderit. Fuga mollitia aperiam
                accusantium accusamus dolor voluptatum quidem nihil harum
                nostrum repellendus possimus vero voluptate, quis vitae.
              </p>
            </ReactWOW>
          </section>
        </article>
      </main>
      <div id="newsletter">
        <p className="font-head font-sm">
          Would you like content like this delivered to your inbox?
        </p>
        <Newsletter
          id="newsletter"
          mailchimpURL="https://gmail.us17.list-manage.com/subscribe/post?u=4ce70e65553c75b0ba1146272&amp;id=6731f94b1c"
        />
      </div>
    </Layout>
  )
}
export default AboutPage

export const pageQuery = graphql`
  query {
    image: file(relativePath: { eq: "nahil-naseer-xljtGZ2-P3Y-unsplash.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 50) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
